/* eslint-disable camelcase */
/* eslint-disable no-use-before-define */
/* eslint-disable import/no-named-as-default-member */
import React, { createContext, useState, useContext, useEffect } from 'react';
import jwtDecode from 'jwt-decode';
import moment from 'moment';
import { getUserProfile, buildErrorMessage } from '../../utils/apiServices';
import { usePopupManager } from '../PopupManager/PopupManager';
import { API_RESOURCE_URLS, USER_OPERATIONS, USER_STATUS } from '../../constants/contants';
// import { API } from '../../apis/api';
// import { logoutAndClearData, getISTTime } from '../../utils/utils';
import config from '../../constants/config'
import keyCloakJson from '../../assets/keycloak.json'
import { postUsageAnalyticsCall } from '../../constants/Utils';


const initializeScript = src =>
    new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = src;
        script.onload = () => resolve();
        script.onError = e => reject(e);
        document.body.appendChild(script);
    });

export const AuthorizationContext = createContext(null);

const AuthorizationHandler = props => {
    const { showInternalError } = usePopupManager();
    const SSO_SESSION_CHECK_INTERVAL_MS = 60000;
    const [user, setUser] = useState({ isLoaded: false });
    const [keycloak, setKeycloak] = useState(null);
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [authPolicies, setAuthPolicies] = useState([]);
    const [authResources, setAuthResources] = useState([]);
    const [authToken, setAuthToken] = useState(null);

    const [remainingTime, setRemainingTime] = useState(null)
    const [refresh, setRefresh] = useState(false)
    const [recentAPICalls, setRecentAPICalls] = useState([]);

    // use bypass keycloak authentication use below states
    // const [user, setUser] = useState({ name: "Jhon Doe", email: "jhondoe@jhon.com", userID: "d30f244d-0267-428f-acf2-9d7fe313beca", supplierCode: "85585", policies: ['edit', "create"], plants: ['1001', '2001', '3001', '1500', '3100'], track_your_vehicle_functions: ["Manufacturing", "admin"], userProfile: "userProfile", isLoaded: true });
    // const [keycloak, setKeycloak] = useState(null);
    // const [isAuthenticated, setIsAuthenticated] = useState(true);
    // const [authPolicies, setAuthPolicies] = useState(['delete', 'download', 'create', 'edit']);
    // const [authResources, setAuthResources] = useState([]);
    // const [authToken, setAuthToken] = useState("dfadfaddf54ad5fa5df5adf5ad");

    const checkSSOSessionStatePeriodically = () => {
        if (localStorage.getItem('stopApiCalls') === 'false') {
            keycloak
                .loadUserInfo()
                .then(() => setTimeout(
                    checkSSOSessionStatePeriodically,
                    SSO_SESSION_CHECK_INTERVAL_MS,
                ))
                .catch(error => {
                    const {
                        // eslint-disable-next-line no-unused-vars
                        sub: userID,
                        exp,
                        iat,
                        auth_time: authTime,
                    } = keycloak.tokenParsed;
                    console.error(
                        `failed user check, error:${buildErrorMessage(error)
                        }; exp:${getISTTime(exp)} iat:${getISTTime(iat)} ` +
                        `auth:${getISTTime(authTime)}`,
                    );
                    refreshTokenAndContinueUserSessionCheckElseLogout();
                });
        }
    };

    const refreshTokenAndContinueUserSessionCheckElseLogout = () => {
        refreshToken()
            .then(() => {
                checkSSOSessionStatePeriodically()
            })
            .catch(error => {
                console.error({ error });
                console.error(
                    `Failed to refresh the token, or the session has expired.Err:${buildErrorMessage(error)
                    } Logging user out...`,
                );
                console.error(buildErrorMessage(error));
                logoutUser();
            });

    }

    // eslint-disable-next-line consistent-return
    const generateUser = async token => {
        try {
            const { name, email, sub: userID, plants, track_your_vehicle_functions, ppap_functions, vendorcode } = jwtDecode(token);
            return { name, email, userID, plants, isLoaded: true, track_your_vehicle_functions };
        } catch (err) {
            // console.error(buildErrorMessage(err));
            showInternalError();
        }
    };

    const loadAuthData = async token => {
        // eslint-disable-next-line no-shadow
        const user = await generateUser(token);
        setUser(user);
        setAuthToken(token);
        postUsageAnalyticsCall(user?.name, user?.userID, 'Landing Page', new Date(), "login", 0)
    };

    const logoutUser = () => {
        postUsageAnalyticsCall(user?.name, user?.userID, 'Landing Page', new Date(), "logout", 0)
        localStorage.setItem('stopApiCalls', false);
        logoutAndClearData(keycloak);
        setIsAuthenticated(false);
        setAuthToken(null);
        setUser(null);
        window.localStorage.clear();
    };

    const refreshToken = () =>
        keycloak
            .updateToken(-1) // -1 for force refresh
            .then(refreshed => {
                // console.info(`token refreshed:${refreshed}${keycloak}`);
                setAuthToken(keycloak.token);
            });

    useEffect(() => {
        if (recentAPICalls.length > 0) {
            refreshToken().catch(err =>
                console.error(`failed to refresh token ${err}`),
            );
        }
    }, [recentAPICalls])
    useEffect(() => {
        if (refresh) {
            refreshToken().catch(err =>
                console.error(`failed to refresh token ${err}`),
            );
            setRefresh(false)
        }
    }, [refresh])

    useEffect(() => {
        if (!authToken) return;
        const expirtytimeInUnixSeconds = keycloak.tokenParsed.exp;
        const currentTimeInUnixSeconds = moment().unix();
        const sixtySeconds = 60;
        const remainingTimeToRefreshInMS =
            (expirtytimeInUnixSeconds - currentTimeInUnixSeconds - sixtySeconds) *
            1000;
        setRemainingTime(remainingTimeToRefreshInMS);
    }, [authToken]);

    useEffect(() => {
        initializeScript(`https://sso.tatamotors.com/auth/js/keycloak.js`)
            .then(() => setKeycloak(window.Keycloak('/keycloak.json')))
            .catch(() => console.error('failed to load keycloak script'));
    }, []);

    useEffect(() => {
        // console.log("inside auth useEffect")
        if (!keycloak) return;
        // console.log("keycloak = ", keycloak)
        keycloak.init({
            onLoad: 'login-required',
            promiseType: 'native',
            pkceMethod: 'S256',
            checkLoginIframe: false,
        })
            .then(authenticated => {
                window.keycloak = keycloak;
                // console.log("Login success = ", authenticated, keycloak)
                setIsAuthenticated(authenticated);
                if (authenticated) {
                    loadAuthData(keycloak.token);
                    checkSSOSessionStatePeriodically();
                }
            })
            .catch(error =>
                console.info('keycloack init error:', error),
                // console.error('keycloack init error:', buildErrorMessage(error)),
            );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [keycloak]);

    const authData = {
        user,
        isAuthenticated,
        logoutUser,
        authPolicies,
        authResources,
        authToken,
        remainingTime,
        setRefresh,
        setRecentAPICalls,
        setRemainingTime
    };

    return <AuthorizationContext.Provider value={authData} {...props} />;
};

const logoutAndClearData = keycloak =>
    keycloak.logout({ redirectUri: config.HOME_UI_BASE_URL }).then(() => {
        window.keycloak = null;
        window.location.href = '/';
    });

const getISTTime = unixTimeInSeconds =>
    moment.unix(unixTimeInSeconds).format('hh:mm:ssa');

export const useAuthorizationContext = () => useContext(AuthorizationContext);

export default AuthorizationHandler;
